export const ANSWER_LABEL = "Frequency";
export const ANSWERS = "Answers";
export const ANSWERS_DATA_KEY = "score";
export const ANSWERS_DATA_VALUE = "answer";
